import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Building2, Package2, Activity } from "lucide-react";
import { whStats } from "../../api/warehouse";

// نغمات KPI الرئيسية: مخازن=بنفسجي، مخزون=أخضر، قيمة=كهرماني، حركات=وردي.
const CARDS = [
  { key: "warehouses_count",    icon: Building2, tone: "bg-violet-500" },
  { key: "stocked_items_count", icon: Package2,  tone: "bg-emerald-500" },
  { key: "total_value",         icon: null,      tone: "bg-amber-500", money: true },
  { key: "today_movements",     icon: Activity,  tone: "bg-rose-500" },
];

const CARD_3D = {
  boxShadow:
    "0 14px 28px rgba(0,0,0,0.32), 0 8px 12px rgba(0,0,0,0.20),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.28), inset 0 -4px 10px rgba(0,0,0,0.18)",
};
const VALUE_3D = {
  textShadow:
    "0 1px 0 rgba(0,0,0,0.20), 0 2px 0 rgba(0,0,0,0.16), 0 3px 0 rgba(0,0,0,0.12), 0 6px 12px rgba(0,0,0,0.40)",
};

// بطاقات KPI للمخازن — البطاقة والأرقام والأيقونات كلها بروز 3D.
export const WhStats = ({ branchId }) => {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    whStats(branchId || undefined).then(setData).catch(() => setData(null));
  }, [branchId]);

  const fmt = (n, money) => new Intl.NumberFormat(i18n.language).format(money ? Math.round(n || 0) : (n || 0));

  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-testid="wh-stats">
      {CARDS.map(({ key, icon: Icon, tone, money }) => (
        <div key={key} data-testid={`wh-kpi-${key}`} style={CARD_3D}
             className={`animate-rise-in rounded-3xl p-4 text-white ${tone}`}>
          <div className="flex items-center justify-between">
            <div className="min-w-0">
              <p className="text-[11px] font-bold uppercase tracking-wide text-white/85">
                {t(`warehouse.kpi.${key}`)}
              </p>
              <p className="num mt-2 font-mono text-2xl font-black" style={VALUE_3D}>
                {fmt(data?.[key], money)}
              </p>
            </div>
            {money ? (
              <span data-testid="wh-kpi-currency" style={VALUE_3D}
                    className="num font-mono text-2xl font-black text-white">
                {data?.currency || "—"}
              </span>
            ) : Icon ? (
              <Icon className="h-9 w-9 text-white drop-shadow-[0_4px_6px_rgba(0,0,0,0.35)]" />
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};
